(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-modalidad', {
            parent: 'entity',
            url: '/ss-modalidad',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSModalidads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-modalidad/s-s-modalidads.html',
                    controller: 'SSModalidadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-modalidad-detail', {
            parent: 'ss-modalidad',
            url: '/ss-modalidad/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSModalidad'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-detail.html',
                    controller: 'SSModalidadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSModalidad', function($stateParams, SSModalidad) {
                    return SSModalidad.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-modalidad',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-modalidad-detail.edit', {
            parent: 'ss-modalidad-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-modalidad.new', {
            parent: 'ss-modalidad',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('ss-modalidad');
                });
            }]
        })
        .state('ss-modalidad.edit', {
            parent: 'ss-modalidad',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-dialog.html',
                    controller: 'SSModalidadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-modalidad.delete', {
            parent: 'ss-modalidad',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-modalidad/ss-modalidad-delete-dialog.html',
                    controller: 'SSModalidadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSModalidad', function(SSModalidad) {
                            return SSModalidad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-modalidad', null, { reload: 'ss-modalidad' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
